import {Empty, Spin} from "antd";
import className from "classnames/bind";
import style from "../style/Gsc.module.scss";

const cn = className.bind(style);

/** Mã ISO-3166-1 alpha-3 (GSC trả về, viết thường) → tên tiếng Việt cho các nước phổ biến. */
const COUNTRY_NAMES = {
	vnm: 'Việt Nam', usa: 'Hoa Kỳ', jpn: 'Nhật Bản', kor: 'Hàn Quốc', chn: 'Trung Quốc',
	sgp: 'Singapore', twn: 'Đài Loan', tha: 'Thái Lan', khm: 'Campuchia', lao: 'Lào',
	mys: 'Malaysia', idn: 'Indonesia', phl: 'Philippines', aus: 'Úc', nzl: 'New Zealand',
	gbr: 'Anh', fra: 'Pháp', deu: 'Đức', can: 'Canada', ind: 'Ấn Độ', rus: 'Nga',
	hkg: 'Hồng Kông', mmr: 'Myanmar', are: 'UAE',
};

const fmt = (n) => Number(n || 0).toLocaleString('vi-VN');

function countryName(code) {
	const c = String(code || '').toLowerCase();
	return COUNTRY_NAMES[c] || c.toUpperCase();
}

/**
 * Khối "Quốc gia hàng đầu": thanh bar theo tỉ trọng clicks + %.
 * rows: [{value: 'vnm', clicks, impressions, ...}] (value là mã quốc gia).
 */
function GscCountries({rows = [], loading = false}) {

	if (loading) {
		return <div style={{textAlign: 'center', padding: '30px 0'}}><Spin /></div>;
	}

	if (!rows.length) {
		return <Empty description="Chưa có dữ liệu quốc gia trong khoảng này." image={Empty.PRESENTED_IMAGE_SIMPLE} />;
	}

	const total = rows.reduce((s, r) => s + Number(r.clicks || 0), 0) || 1;
	const max   = Math.max(1, ...rows.map((r) => Number(r.clicks || 0)));

	return (
		<div className={cn('barList')}>
			{rows.slice(0, 15).map((r) => {
				const share = Math.round((Number(r.clicks || 0) / total) * 100);
				const width = Math.max(2, Math.round((Number(r.clicks || 0) / max) * 100));

				return (
					<div key={r.value} className={cn('barRow')}>
						<div className={cn('barName')}>{countryName(r.value)}</div>
						<div className={cn('barTrack')}>
							<div className={cn('barFill')} style={{width: `${width}%`}} />
						</div>
						<div className={cn('barValue')}>
							<span>{fmt(r.clicks)}</span>
							<span className={cn('barPct')}>{share < 1 ? '<1' : share}%</span>
						</div>
					</div>
				);
			})}
		</div>
	);
}

export default GscCountries;
